import React from 'react';

import { FirstPageOutlined, MenuOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { toggleLeftDrawerOpen, useLeftDrawerOpen } from '../../documents/editor/EditorContext';

function useIcon() {
  const leftDrawerOpen = useLeftDrawerOpen();
  if (leftDrawerOpen) {
    return <FirstPageOutlined fontSize="small" />;
  }
  return <MenuOutlined fontSize="small" />;
}

export default function ToggleSamplesPanelButton() {
  const icon = useIcon();
  return <IconButton onClick={toggleLeftDrawerOpen}>{icon}</IconButton>;
}
